import React from 'react'
import DatePicker from 'react-datepicker'

import { DateRange } from '../../../../types/date-range'

import { TimeInputField, TimePickerColumn, TimePickerColumns } from './time-picker.styled'

interface Props {
  dateRange: DateRange
  onChange: (dateRange: DateRange) => void
}

export const DateRangePicker = ({ dateRange, onChange }: Props) => {
  const { fromDate, toDate } = dateRange
  return (
    <TimePickerColumns>
      <TimePickerColumn>
        From:
        <DatePicker
          selected={fromDate}
          onChange={(date) => onChange({ fromDate: date || new Date(), toDate })}
          dateFormat="dd/MM/yyyy"
          customInput={<TimeInputField />}
        />
      </TimePickerColumn>
      <TimePickerColumn>
        To:
        <DatePicker
          selected={toDate}
          onChange={(date) => onChange({ fromDate, toDate: date || new Date() })}
          dateFormat="dd/MM/yyyy"
          customInput={<TimeInputField />}
        />
      </TimePickerColumn>
    </TimePickerColumns>
  )
}
